import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./rules.css";

const UserRules = () => {
  const dispatch = useDispatch();
  const [rules, setRules] = useState([]);

  // Try to get theme data from Redux if available
  const themeData = useSelector((state) => {
    // Check if there's a theme state in Redux
    if (state.theme && state.theme.data) {
      return state.theme.data;
    }
    return null;
  });

  useEffect(() => {
    if (themeData && Array.isArray(themeData.rules)) {
      setRules(themeData.rules);
    }
  }, [themeData]);

  return (
    <div className="user-rules-container">
      <h1>Rules</h1>
      <div className="rules-content">
        {rules && rules.length > 0 ? (
          <ul className="rules-list">
            {rules.map((rule, index) => (
              <li key={index} className="rule-item">
                {rule}
              </li>
            ))}
          </ul>
        ) : (
          <p className="no-rules">No rules available at this time.</p>
        )}
      </div>
    </div>
  );
};

export default UserRules;
